module.exports = __webpack_public_path__ + "img/news-6.e0ebe7fd.jpeg";